const UNICODE_NON_BREAKING_SPACE = String.fromCharCode(160);
const USUAL_SPACE = String.fromCharCode(32);

var currencyFormat = (amount, { locale = 'pt-BR', currency = 'BRL' } = {}) => Intl
  .NumberFormat(locale, { style: 'currency', currency })
  .format(amount)
  .replace(UNICODE_NON_BREAKING_SPACE, USUAL_SPACE);

export { currencyFormat as default };
//# sourceMappingURL=currency-format.js.map
